// extracted by mini-css-extract-plugin
export var menuIcon = "_q9-0";
export var menuIconInline = "_q9-1";